import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:4000";

// Create axios instance with credentials
export const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

// Global 401 handler function (will be set by AuthProvider)
let handleSessionExpiry = null;

export const setSessionExpiryHandler = (handler) => {
  handleSessionExpiry = handler;
};

// Response interceptor to handle 401 responses globally
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle 401 Unauthorized responses
    if (error.response?.status === 401) {
      // Don't redirect if already on an auth page
      const authPaths = ['/signin', '/signup', '/forgot-password', '/reset-password', '/verify-email', '/verify-email-change'];
      const currentPath = window.location.pathname;
      
      // Only trigger session expiry handler if not on auth pages
      if (!authPaths.includes(currentPath) && handleSessionExpiry) {
        handleSessionExpiry();
      }
    }
    
    // Re-throw the error for component-level handling
    return Promise.reject(error);
  }
);

export { API_BASE_URL };
